import { render } from "./ItemQuantitySetter.vue?vue&type=template&id=497c7e6b&scoped=true"
import script from "./ItemQuantitySetter.vue?vue&type=script&lang=js"
export * from "./ItemQuantitySetter.vue?vue&type=script&lang=js"

import "./ItemQuantitySetter.vue?vue&type=style&index=0&id=497c7e6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-497c7e6b"

export default script